/**
 * @fileoverview AR-805 — public entry point of the Classroom integration
 * layer (ports & adapters). Screens import ONLY from here.
 */

export * from './types'
export * from './phase3Types'
export * from './ports'
export { getClassroomAdapters, getClassroomCapabilities } from './provider'
export { CLASSROOM_MOCK_SCENARIO_KEY } from './adapters/mockAdapter'
export { useClassroomIntegrationEnabled } from './hooks/useClassroomIntegrationEnabled'
export { useClassroomConnection } from './hooks/useClassroomConnection'
export { useClassroomCourses } from './hooks/useClassroomCourses'
export { useProjectClassroomLink } from './hooks/useProjectClassroomLink'
export type { ProjectLinkBusyAction } from './hooks/useProjectClassroomLink'
export { useClassroomSync, totalImported } from './hooks/useClassroomSync'
export { useRefreshOnFocus } from './hooks/useRefreshOnFocus'
export { useClassroomGrade } from './hooks/useClassroomGrade'
